import { Component } from '@angular/core';

@Component({
    selector: 'mapp-history-not-found',
    templateUrl: './history-not-found.component.html',
    styleUrls: ['./history-not-found.component.scss'],
    standalone: false,
})
export class HistoryNotFoundComponent {}
